export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            关于我们
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            了解7777影院的故事与使命
          </p>
        </div>

        <div className="bg-background-100 border border-background-200 rounded-2xl p-8 md:p-12">
          <div className="max-w-3xl mx-auto space-y-5">
            <p className="text-foreground-700 leading-relaxed text-base">
              7777影院成立于2018年，是国内领先的免费高清影视在线观看平台。经过多年发展，
              我们已建立起覆盖电影、电视剧、综艺、动漫、纪录片等全品类的内容库，累计服务超过700万影迷用户。
            </p>
            <p className="text-foreground-700 leading-relaxed text-base">
              我们始终秉持"让每个人都能免费看好片"的理念，投入大量资源建设CDN分发网络和视频转码系统，
              确保每一位用户无论身在何处，都能享受到流畅、高清的观影体验。同时，我们的内容编辑团队
              全天候追踪全球影视动态，确保最新、最热的影视资源第一时间上线。
            </p>
            <p className="text-foreground-700 leading-relaxed text-base">
              未来，7777影院将继续优化播放技术，拓展内容来源，为影迷们提供更加丰富、便捷的
              免费观影服务。感谢每一位用户的支持与信任，是你们让7777影院变得更好。
            </p>

            <div className="grid grid-cols-3 gap-6 pt-6 border-t border-background-200">
              {[
                { num: '700万+', label: '忠实用户' },
                { num: '10万+', label: '影视资源' },
                { num: '200+/天', label: '日更新量' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-1">
                    {stat.num}
                  </div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}